import { css } from "@emotion/react";
import type { DeepReadonly } from "@itandi/itandi-bb-ui";
import { colors, RiAlertFill } from "@itandi/itandi-bb-ui";
import type { FC } from "react";

const Icons = {
	Alert: RiAlertFill
};

type Props = DeepReadonly<{
	variant?: keyof typeof Icons;
}>;

const styles = {
	variant: {
		Alert: css({ color: colors["semantic-warning"] })
	}
} as const;

/**
  @deprecated 削除したい場合は相談ワークフローからデザインの修正を依頼してください（新しい画面では使わないでください）
 */
export const StatusIcon: FC<Props> = ({ variant = "Alert" }) => {
	const Icon = Icons[variant];

	return (
		<Icon
			css={css(
				{
					height: 16,
					width: 16
				},
				styles.variant[variant]
			)}
		/>
	);
};
